import app from 'app';

import blogHeroBanner from './blog/blog-hero-banner';

app.add({
  'blog-hero-banner': blogHeroBanner,
});
